import { formatText, formatVal, valToPercent } from '../../../../helpers/value'

export const schema = {
  rank: {
    label: 'industryOverview.businessProvince.RANK',
    key: 'rank',
    format: (val, locale) => formatVal(val, locale, false, 0),
    thStyle: {},
  },
  provinceName: {
    label: 'industryOverview.businessProvince.PROVINCE',
    key: 'provinceName',
    format: (val) => formatText(val),
    thStyle: {},
  },
  region: {
    label: 'industryOverview.businessProvince.REGION',
    key: 'region',
    format: (val) => formatText(val),
    thStyle: {},
  },
  numberBusiness: {
    label: 'industryOverview.businessProvince.NUMBER_OF_COMPANIES',
    key: 'numberBusiness',
    format: (val, locale) => formatVal(val, locale, false, 0),
    thStyle: {
      justifyContent: 'flex-end',
    },
  },
  totalPercentCompanies: {
    label: 'industryOverview.businessProvince.TOTAL_COMPANIES_PERCENT',
    key: 'totalPercentCompanies',
    format: (val, locale) => valToPercent(val, locale),
    thStyle: {
      justifyContent: 'flex-end',
    },
  },
}

export const mapViewBy = {
  map: {
    label: 'industryOverview.businessProvince.MAP',
    value: 'Map',
    isI18n: true,
  },
  table: {
    label: 'industryOverview.businessProvince.TABLE',
    value: 'Table',
    isI18n: true,
  },
}
